"use client"

import { Dialog, DialogContent } from "@/components"
import { IconButton } from "@/elements"
import type { NovaSession } from "@/types"
import { FragmentType, graphql, useFragment } from "@/gql"
import { AboutContentIsProFragmentDoc } from "@/gql/graphql"
import { XMarkIcon } from "@heroicons/react/24/outline"
import { FC } from "react"
import { usePortfolio } from "../hooks/usePortfolio"
import { PortfolioUIState } from "../page"
import { AboutContent } from "./AboutContent"
import { useEditPortfolio } from "./edit/useEditPortfolio"
import { PortfolioHeaderDesktop } from "./PortfolioHeaderDesktop"

const AboutModalFragment = graphql(`
  fragment AboutModal on IndividualCreative {
    id
    __typename
    ...PortfolioHeader
    ...AboutContent
  }
`)

interface Props {
  creative: FragmentType<typeof AboutModalFragment> | null | undefined
  uiState: PortfolioUIState
  serverSession: NovaSession | null
  editProfileMethods?: ReturnType<typeof useEditPortfolio>
  viewerUser: FragmentType<typeof AboutContentIsProFragmentDoc> | null | undefined
}

export const AboutModal: FC<Props> = props => {
  const { uiState, serverSession, editProfileMethods, viewerUser } = props
  const creative = useFragment(AboutModalFragment, props.creative)
  const { setShowAboutModal, showAboutModal } = usePortfolio()
  const open = showAboutModal

  return (
    <Dialog open={open}>
      <DialogContent className="sm:rounded-xl">
        <div className="relative h-full w-[800px] overflow-y-scroll px-8 pb-8 pt-[100px] sm:max-modal-size lg:max-w-xl lg:px-10 lg:pb-10 xl:w-[1000px] xl:px-[96px] xl:pb-[96px]">
          <div className="fixed right-0 top-0 mb-6 mt-9 flex h-[36px] w-full flex-row items-center justify-end px-8">
            <IconButton onClick={() => setShowAboutModal(false)} Icon={XMarkIcon} variant="white" />
          </div>
          <PortfolioHeaderDesktop
            size="sm"
            creative={creative?.__typename === "IndividualCreative" ? creative : undefined}
            uiState={uiState}
            serverSession={serverSession}
            editProfileMethods={editProfileMethods}
          />
          <div className="mt-10 w-full">
            <AboutContent
              editProfileMethods={editProfileMethods}
              uiState={uiState}
              creative={creative?.__typename === "IndividualCreative" ? creative : undefined}
              serverSession={serverSession}
              viewerUser={viewerUser}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
